/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { Image } from '@components/atoms'
import { AppBar, Toolbar } from '@mui/material'
import { View } from '@components/atoms'
import logoPng from '@public/images/logo/logo_title_white.png'

export const SimpleNav = () => {
	return (
		<AppBar
			position="fixed"
			color="transparent"
			sx={{ zIndex: theme => theme.zIndex.drawer + 1 }}
			component="nav"
			elevation={0}
		>
			<Toolbar css={style}>
				<View className="nav">
					<Image src={logoPng} className="logoTitleWhite" />
				</View>
			</Toolbar>
		</AppBar>
	)
}

const style = css({
	position: 'relative',
	zIndex: 10,
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	whiteWpace: 'nowrap',
	top: '0px',
	width: '100%',
	fontSize: '15px',

	'.nav': {
		position: 'relative',
		display: 'flex',
		justifyContent: 'flex-start',
		alignItems: 'center',
		width: '100%',
		height: '64px',
		paddingLeft: '1rem',
		paddingRight: '1rem',
	},

	'.logoTitleWhite': {
		height: '3rem',
		width: 'auto',
		marginLeft: '1rem',
		textAlign: 'left',
		opacity: '0.7',
	},

	'@media (max-width: 810px)': {
		'&': {
			height: 0,
			minHeight: 0,
		},

		'.nav': {
			height: 0,
		},
	},
})
